module.exports = __webpack_public_path__ + "img/botella_black_5.05ff0020.jpeg";